import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const devPath = process.env.REACT_APP_I18N_DEV_PATH;

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(intervalPlural)
  .use(initReactI18next)
  .init({
    returnNull: false,
    backend: {
      loadPath: `${devPath === '1' ? '' : '/maf-external-portal'}/locales/{{lng}}/{{ns}}.json`,
    },
    fallbackLng: 'en',
    load: 'languageOnly',
    ns: ['auth', 'menu', 'translation'],
    defaultNS: 'translation',
    detection: { lookupLocalStorage: 'i18nextLngEdesk' },
  });

i18n.on('languageChanged', (lng) => {
  if (lng === 'xx') {
    i18n.options.fallbackLng = false;
  } else {
    i18n.options.fallbackLng = 'en';
  }
});

export default i18n;
